import { useTranslation } from "react-i18next";
import { FillTheFieldErrorMessage, FormInput } from "@/shared/Components";
import { FieldLayout } from "@/pages/ContactsPage/Components/FieldLayout";
import type { FC } from "react";
import type { FieldProps } from "@/pages/ContactsPage/types";

export const AddressField: FC<FieldProps> = ({ index }) => {
  const { t } = useTranslation();

  return (
    <FieldLayout>
      <FillTheFieldErrorMessage name={`addresses.${index}`} />
      <FormInput
        name={`addresses.${index}.addressType.name`}
        placeholder={t("contactsPage.generalInfo.type")}
      />
      <FormInput
        name={`addresses.${index}.addressStreet1`}
        placeholder={t("contactsPage.generalInfo.street", {
          number: 1,
        })}
      />
      <FormInput
        name={`addresses.${index}.addressStreet2`}
        placeholder={t("contactsPage.generalInfo.street", {
          number: 2,
        })}
      />
      <FormInput
        name={`addresses.${index}.addressCity`}
        placeholder={t("contactsPage.generalInfo.city")}
      />
      <FormInput
        name={`addresses.${index}.addressCountry`}
        placeholder={t("contactsPage.generalInfo.country")}
      />
      <FormInput
        name={`addresses.${index}.addressPostalCode`}
        placeholder={t("contactsPage.generalInfo.postcode")}
      />
    </FieldLayout>
  );
};
